import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import PillButton from '../components/PillButton';

function InspirationPage() {
  const [inspirationMessage, setInspirationMessage] = useState('');

  const showInspirationMessage = () => {
    setInspirationMessage(
      <p>
        "Creativity is intelligence having fun." – Albert Einstein
      </p>
    );
  };

  return (
    <>
      {/* Hero Section */}
      <header className="hero-section text-center" role="banner">
        <div className="container">
          <h1>Inspiration for Web Developers</h1>
          <p className="lead">Discover ideas and resources to spark your creativity</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container py-5" role="main">
        <section id="inspiration-content" aria-labelledby="inspiration-heading">
          <h2 id="inspiration-heading">Get Inspired</h2>
          <p>
            Building web projects can be more exciting when you draw inspiration from creative ideas and real-world examples. Here are a few resources to get you started.
          </p>

          {/* Chunk 1: Awwwards */}
          <div className="chunk">
            <h3>1. Awwwards</h3>
            <p>
              Awwwards showcases the best in web design and development, featuring award-winning websites with innovative designs.
            </p>
            <div className="code-snippet">
              <pre>
                {`// Example URL
https://www.awwwards.com`}
              </pre>
            </div>
            <p>
              <a
                href="https://www.awwwards.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-pill"
              >
                Visit Awwwards
              </a>
            </p>
            <div className="tip">
              <strong>Tip:</strong> Explore the "Sites of the Day" section for daily inspiration.
            </div>
          </div>

          {/* Chunk 2: Dribbble */}
          <div className="chunk">
            <h3>2. Dribbble</h3>
            <p>
              Dribbble is a community of designers sharing their work, including UI/UX designs, illustrations, and more.
            </p>
            <div className="code-snippet">
              <pre>
                {`// Example URL
                    https://dribbble.com`}
              </pre>
            </div>
            <p><strong>Try it:</strong> Click below to see an inspirational quote!</p>
            <PillButton onClick={showInspirationMessage}>Show Quote</PillButton>
            <div id="inspiration-message">{inspirationMessage}</div>
            <div className="tip">
              <strong>Tip:</strong> Follow designers on Dribbble to stay updated with their latest work.
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default InspirationPage;